<template>
  <div>
    <v-row align="center" justify="center" dense>
      <v-col cols="2" md="2" sm="12">
        <h3 align="center">Plantilla:</h3>
      </v-col>
      <v-col cols="6" md="6" sm="12">
        <validation-provider v-slot="{ errors }" name="Nombre" rules="required">
          <v-text-field
            required
            v-model="model.name"
            :error-messages="errors"
            label="nombre"
          ></v-text-field>
        </validation-provider>
      </v-col>
      <v-col cols="4" md="4" sm="12">
        <validation-provider
          v-slot="{ errors }"
          name="Privacidad"
          rules="required"
        >
          <v-radio-group
            v-model="model.type"
            row
            required
            :error-messages="errors"
          >
            <v-radio label="Pública" :value="1"></v-radio>
            <v-radio label="Privado" :value="2"></v-radio>
          </v-radio-group>
        </validation-provider>
      </v-col>
      <br />
    </v-row>
    <v-row class="mb-5">
      <v-col>
        <validation-provider
          v-slot="{ errors }"
          name="Nota médica"
          rules="required"
        >
          <vue-editor
            v-model="model.templateHTML"
            :errors-message="errors"
            required
          />
          <span class="error--text">{{ errors.toString() }}</span>
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  props: {
    model: Object,
  },
  components: {
    VueEditor,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {};
  },
};
</script>

<style></style>
